// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
  // 完全显示的时候加载
  preLoad: 1,
  // 失败时显示的图片
  error: require('../static/img/error.png'),
  // 加载时显示的GIF图
  loading: require('../static/img/loading.gif'),
  // 尝试加载几次
  attempt: 1
})
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js